import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { delay, filter, map, tap } from 'rxjs/operators';
import { AccountsService, AuthService, TokenService } from './auth';
import { BaseService, SpinComponent } from './services';
import { DirectivesModule, PipesModule, SharedModule, ThemeService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  imports: [RouterOutlet, SpinComponent, SharedModule, DirectivesModule, PipesModule],
})
export class AppComponent extends BaseService implements OnInit {
  readonly #destroyRef: DestroyRef = inject(DestroyRef);
  readonly #activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  readonly #router = inject(Router);

  readonly #themeService = inject(ThemeService);
  readonly #authService = inject(AuthService);
  readonly #tokenService = inject(TokenService);
  readonly #accountService = inject(AccountsService);

  ngOnInit(): void {
    this.#authService.initializeScheduler();
    if (this.#tokenService.token || this.#tokenService.refreshToken) {
      void this.#accountService.loadAccountIds().catch((): void => {
        // Guards and refresh handling own invalid persisted sessions.
      });
    }
    this.#router.events.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });

    this.#activatedRoute.queryParams
      .pipe(
        delay(1),
        map((params) => <string>params['theme']?.match(/^[A-Za-z0-9\s]+/)?.[0]),
        filter((theme): theme is 'dark' | 'light' | 'auto' => ['dark', 'light', 'auto'].includes(theme)),
        tap((theme) => {
          this.#themeService.setColorMode(theme);
        }),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe();
  }
}
